"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MoreMenu = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
/**
 * RedPanda UI - MoreMenu（「⋯」選單）
 * docs/介面優化.md §3-5、R5、R24：操作超過 3 個、或不常用的管理功能，收進「⋯」選單
 * - variant="button"：頁首用，40px 框線方塊（與主要按鈕同高）、水平「⋯」
 * - variant="icon"：卡片、列表列用，無框小圖示、垂直「⋮」
 * 點選單外、按 Esc、選了項目都會關閉
 */
const react_1 = require("react");
const outline_1 = require("@heroicons/react/24/outline");
const utils_1 = require("../../utils");
const MoreMenu = ({ items, label, variant = 'button', className }) => {
    const [open, setOpen] = (0, react_1.useState)(false);
    const menuRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(() => {
        if (!open)
            return;
        const handleClickOutside = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target))
                setOpen(false);
        };
        const handleKeyDown = (event) => {
            if (event.key === 'Escape')
                setOpen(false);
        };
        document.addEventListener('mousedown', handleClickOutside);
        document.addEventListener('keydown', handleKeyDown);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [open]);
    if (items.length === 0)
        return null;
    const Icon = variant === 'button' ? outline_1.EllipsisHorizontalIcon : outline_1.EllipsisVerticalIcon;
    return ((0, jsx_runtime_1.jsxs)("div", { className: (0, utils_1.cn)('relative', className), ref: menuRef, children: [(0, jsx_runtime_1.jsx)("button", { type: "button", onClick: (e) => {
                    // 卡片、列表列常整塊可點或可拖曳，選單按鈕不要把點擊傳上去
                    e.stopPropagation();
                    setOpen(!open);
                }, "aria-haspopup": "menu", "aria-expanded": open, "aria-label": label, title: label, className: variant === 'button'
                    ? 'inline-flex h-10 w-10 items-center justify-center rounded-md border border-line bg-surface text-fg-secondary transition-colors hover:text-fg hover:bg-gray-100 dark:hover:bg-slate-800'
                    : 'inline-flex items-center justify-center rounded p-0.5 text-fg-muted transition-colors hover:text-fg', children: (0, jsx_runtime_1.jsx)(Icon, { className: variant === 'button' ? 'h-5 w-5' : 'h-4 w-4', "aria-hidden": "true" }) }), open && ((0, jsx_runtime_1.jsx)("div", { role: "menu", className: (0, utils_1.cn)('absolute right-0 z-50 min-w-[10rem] rounded-md border border-line bg-surface py-1 shadow-lg', variant === 'button' ? 'top-11' : 'top-6'), children: items.map(item => ((0, jsx_runtime_1.jsx)("button", { type: "button", role: "menuitem", onClick: (e) => {
                        e.stopPropagation();
                        setOpen(false);
                        item.onClick();
                    }, className: (0, utils_1.cn)('block w-full px-4 py-2 text-left text-sm whitespace-nowrap hover:bg-gray-100 dark:hover:bg-slate-800', item.tone === 'danger' ? 'text-red-600 dark:text-red-400' : 'text-fg'), children: item.label }, item.key))) }))] }));
};
exports.MoreMenu = MoreMenu;
exports.MoreMenu.displayName = 'MoreMenu';
